import React from 'react'
import { useAppSelector } from '../../../slices/store'
import { EStages } from '../../../utils/types';
import { Lobby } from './Lobby/Lobby';
import { AddSongs } from './AddSongs/AddSongs';
import { Results } from './Results/Results';
import { Vote } from './Vote/Vote';
import { StyledStage } from './styles';

export const Stage = () => {
  const {stage} = useAppSelector(s => s.mainStore);
  console.log(stage);

  if (!stage) {
    return null;
  }

  return (<StyledStage>
    {
      {
        [EStages.lobby]: <Lobby />,
        [EStages.add_songs]: <AddSongs />,
        [EStages.results]: <Results />,
        [EStages.vote]: <Vote />,
      }[stage]
    }
  </StyledStage>
  )
}
